import { html, css } from 'lit';
import WarpElement from '@warp-ds/elements-core';
import { customElement } from 'lit/decorators/custom-element.js';

@customElement('base-card')
export class BaseCard extends WarpElement {
	static styles = [
		...WarpElement.styles,
		css`
			/** The line below is where the injected CSS goes, removing it means you get no CSS from the design system **/
			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.focus\:rounded-8:focus{border-radius:8px}.hover\:no-underline:hover,.focus\:no-underline:focus{text-decoration:none}.focus\:focusable:focus{outline:2px solid var(--w-s-color-border-focus);outline-offset:var(--w-outline-offset,1px)}.static{position:static}.p-1{padding:.1rem};
		`,
	]

	linkUrl: string = '';


	static properties = {
		linkUrl: { type: String },
	};
	render() {

		return html`
			<article aria-labelledby="base-card-title" class="rounded-8">
				<a href=${this.linkUrl} class="p-1 s-text hover:no-underline focus:no-underline focus:focusable focus:rounded-8" @click=${(e: Event) => {
					this.dispatchEvent(
						new CustomEvent('base-card-click', {
							detail: { originalEvent: e },
							bubbles: true,
							composed: true
						})
					);
				}}">
					<slot></slot>
				</a>
			</article>
			`;
	}
}
